<template>
	<div class="solution-div" id="solution-div">
		<div class="os-wrapper row">
			<div class="col-3">
				<span class="a-t px-4 py-2 cc-h fxt-srvs-header">
					<svg
						x="0px"
						y="0px"
						viewBox="0 0 480.049 480.049"
						style="enable-background: new 0 0 480.049 480.049"
						xml:space="preserve"
					>
						<g>
							<g>
								<path
									d="M448.027,160.049h-104c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8h24c8.837,0,16,7.163,16,16s-7.163,16-16,16h-24
                                  c-4.418,0-8,3.582-8,8v40h-120c-4.418,0-8,3.582-8,8v104c0,17.673,14.327,32,32,32h208c17.673,0,32-14.327,32-32v-208
                                  C480.027,174.376,465.7,160.049,448.027,160.049z M336.027,416.049h-96c-8.837,0-16-7.163-16-16v-96h112v16h-16
                                  c-17.673,0-32,14.327-32,32c0,17.673,14.327,32,32,32h16V416.049z M464.027,400.049c0,8.837-7.163,16-16,16h-96v-40
                                  c0-4.418-3.582-8-8-8h-24c-8.837,0-16-7.163-16-16s7.163-16,16-16h24c4.418,0,8-3.582,8-8v-24h24v16c0,17.673,14.327,32,32,32
                                  c17.673,0,32-14.327,32-32v-16h24V400.049z M464.027,288.049h-32c-4.418,0-8,3.582-8,8v24c0,8.837-7.163,16-16,16s-16-7.163-16-16
                                  v-24c0-4.418-3.582-8-8-8h-32v-32h16c17.673,0,32-14.327,32-32s-14.327-32-32-32h-16v-16h96c8.837,0,16,7.163,16,16V288.049z"
								></path>
							</g>
						</g>
						<g>
							<g>
								<path
									d="M352.027,32.049h-16v-24c0-4.418-3.582-8-8-8h-104c-17.673,0-32,14.327-32,32v89.6l-33.096,16
                                  c-4.977-6.574-11.155-12.145-18.208-16.416c31.601-15.834,44.383-54.288,28.549-85.889C153.438,3.743,114.984-9.039,83.383,6.795
                                  C51.782,22.629,39,61.083,54.834,92.684c5.46,10.896,13.917,20.007,24.377,26.261c-16.745,8.166-29.112,23.208-33.888,41.216
                                  l-31.872,100.36c-9.017,28.347-7.183,59.032,5.144,86.104c13.074,28.616,12.462,61.617-1.664,89.728l-16.064,32.12
                                  c-1.975,3.952-0.372,8.757,3.58,10.732c1.112,0.555,2.337,0.844,3.58,0.844h88c4.418,0,8-3.582,8-8
                                  c0.024-14.848-8.225-28.473-21.392-35.336l3.824-7.632c11.58-23.28,15.348-49.673,10.744-75.264l-5.936-32.64
                                  c-0.76-4.213,2.04-8.245,6.253-9.005c0.45-0.081,0.906-0.122,1.363-0.123c3.744-0.004,6.956,2.669,7.632,6.352l10.864,59.776
                                  c1.761,9.709,2.648,19.557,2.648,29.424v64.448c0,4.418,3.582,8,8,8h88c4.418,0,8-3.582,8-8c0-1.556-0.091-3.111-0.272-4.656
                                  c-1.376-12.041-8.812-22.543-19.712-27.84c-8.924-4.548-19.262-5.465-28.848-2.56l5.328-26.624
                                  c2.328-11.656,3.501-23.514,3.504-35.4v-71.608l-9.344-107.128l55.512-26.488c10.258-4.562,17.095-14.486,17.704-25.696h80.128
                                  c4.418,0,8-3.582,8-8v-40h16c17.673,0,32-14.327,32-32S369.7,32.049,352.027,32.049z M64.027,64.049c0-26.51,21.49-48,48-48
                                  c26.51,0,48,21.49,48,48s-21.49,48-48,48C85.529,112.023,64.054,90.548,64.027,64.049z M175.187,454.305
                                  c6.662-3.781,14.779-3.958,21.6-0.472c4.371,2.118,7.826,5.747,9.728,10.216h-70.488v-56.448
                                  c-0.001-10.828-0.975-21.634-2.912-32.288l-10.864-59.768c-2.234-12.922-14.521-21.586-27.442-19.351
                                  c-12.922,2.234-21.586,14.521-19.351,27.442c0.023,0.135,0.048,0.27,0.074,0.405l5.944,32.64
                                  c3.983,22.184,0.712,45.061-9.328,65.24l-7.768,15.528c-2.002,3.939-0.432,8.755,3.507,10.757
                                  c0.553,0.281,1.138,0.497,1.741,0.643c7.882,1.857,14.289,7.577,17.024,15.2h-65.68l10.256-20.544
                                  c16.291-32.428,16.997-70.494,1.92-103.504c-10.69-23.466-12.281-50.067-4.464-74.64l32-100.8
                                  c6.64-24.877,31.351-40.414,56.648-35.616c10.455,2.094,19.892,7.666,26.776,15.808l-47.28,22.84
                                  c-10.239,4.981-16.755,15.35-16.8,26.736c-0.04,16.374,13.201,29.681,29.575,29.721c4.467,0.011,8.878-0.987,12.905-2.921
                                  l36.8-17.544l8.72,100.464v70.92c-0.009,10.831-1.081,21.635-3.2,32.256l-8.528,42.608c-0.87,4.332,1.935,8.549,6.267,9.419
                                  c1.898,0.381,3.869,0.062,5.549-0.899L175.187,454.305z M223.651,155.153l-0.24,0.104l-107.8,51.432
                                  c-6.829,3.252-15.002,0.352-18.254-6.478c-0.875-1.838-1.329-3.847-1.33-5.882c0.02-5.247,3.02-10.027,7.736-12.328l108.664-52.48
                                  c4.321-1.929,9.329-1.513,13.272,1.104c3.982,2.557,6.372,6.98,6.328,11.712C232.025,147.893,228.739,152.921,223.651,155.153z
                                   M352.027,80.049h-24c-4.418,0-8,3.582-8,8v40h-75.608c-7.031-12.987-22.492-18.894-36.392-13.904V32.049c0-8.837,7.163-16,16-16
                                  h96v24c0,4.418,3.582,8,8,8h24c8.837,0,16,7.163,16,16S360.864,80.049,352.027,80.049z"
								></path>
							</g>
						</g>
						<g>
							<g>
								<path
									d="M322.371,210.393l-26.344,26.344v-44.688h-16v60.688l-8,8l-8-8v-28.688h-16v12.688l-26.344-26.344l-11.312,11.312l56,56
                                  c3.124,3.123,8.188,3.123,11.312,0l56-56L322.371,210.393z"
								></path>
							</g>
						</g>
						<g>
							<g>
								<rect x="248.027" y="192.049" width="16" height="16"></rect>
							</g>
						</g>
						<g>
							<g>
								<rect x="248.027" y="160.049" width="16" height="16"></rect>
							</g>
						</g>
						<g>
							<g>
								<rect x="280.027" y="160.049" width="16" height="16"></rect>
							</g>
						</g>
						<g></g>
						<g></g>
						<g></g>
						<g></g>
						<g></g>
						<g></g>
						<g></g>
						<g></g>
						<g></g>
						<g></g>
						<g></g>
						<g></g>
						<g></g>
						<g></g>
						<g></g>
					</svg>
					<h5 class="">On-demand Solutions</h5>
				</span>
				<ul class="serv-ul">
					<li>
						<a href="#">
							<span class="submenuicon">
								<svg width="20" height="19.062" viewBox="0 0 20 19.062">
									<g transform="translate(0 -12)">
										<g transform="translate(9.609 28.055)">
											<g transform="translate(0 0)">
												<path
													class="a"
													d="M246.667,423.114a.39.39,0,1,0,.115.276A.393.393,0,0,0,246.667,423.114Z"
													transform="translate(-246 -423)"
												></path>
											</g>
										</g>
										<g transform="translate(6.484 23.902)">
											<path
												class="a"
												d="M171.97,316.688h-4.908A1.063,1.063,0,0,0,166,317.75v.533a1.063,1.063,0,0,0,1.062,1.062h4.908a1.063,1.063,0,0,0,1.062-1.062v-.533A1.063,1.063,0,0,0,171.97,316.688Zm-4.407,1.875h-.5a.281.281,0,0,1-.28-.28v-.533a.281.281,0,0,1,.28-.28h.5Zm1.563,0h-.781v-1.094h.781Zm1.562,0h-.781v-1.094h.781Zm1.563-.28a.281.281,0,0,1-.28.28h-.5v-1.094h.5a.281.281,0,0,1,.28.28Z"
												transform="translate(-166 -316.688)"
											></path>
										</g>
										<g transform="translate(9.296 18.568)">
											<path
												class="a"
												d="M238.657,180.254a.391.391,0,1,0,.115.277A.393.393,0,0,0,238.657,180.254Z"
												transform="translate(-237.99 -180.14)"
											></path>
										</g>
										<g transform="translate(1.485 23.934)">
											<path
												class="a"
												d="M39.493,317.5a1.484,1.484,0,1,0,1.484,1.484A1.486,1.486,0,0,0,39.493,317.5Zm0,2.188a.7.7,0,1,1,.7-.7A.7.7,0,0,1,39.493,319.688Z"
												transform="translate(-38.009 -317.5)"
											></path>
										</g>
										<g transform="translate(15.547 23.934)">
											<path
												class="a"
												d="M399.5,317.5a1.484,1.484,0,1,0,1.484,1.484A1.486,1.486,0,0,0,399.5,317.5Zm0,2.188a.7.7,0,1,1,.7-.7A.7.7,0,0,1,399.5,319.688Z"
												transform="translate(-398.015 -317.5)"
											></path>
										</g>
										<g transform="translate(0 12)">
											<g transform="translate(0 0)">
												<path
													class="a"
													d="M17.891,28.836h.156A1.955,1.955,0,0,0,20,26.883V24.564a1.941,1.941,0,0,0-.927-1.662l-.2-.121h.732A.391.391,0,0,0,20,22.391V20.853a.391.391,0,0,0-.391-.391h-1.23a.391.391,0,0,0-.339.2l-.394.689-.919-3.743a2.635,2.635,0,0,0-1.961-1.942V13.419A1.421,1.421,0,0,0,13.346,12H6.654a1.421,1.421,0,0,0-1.419,1.419v2.244a2.635,2.635,0,0,0-1.961,1.942l-.919,3.742-.394-.689a.391.391,0,0,0-.339-.2H.391A.391.391,0,0,0,0,20.853v1.537a.391.391,0,0,0,.391.391h.732l-.2.121A1.941,1.941,0,0,0,0,24.564v2.319a1.955,1.955,0,0,0,1.953,1.953h.156v.586a1.63,1.63,0,0,0,.244.859h-.42a.391.391,0,1,0,0,.781H8.917a.391.391,0,1,0,0-.781H5.147a1.63,1.63,0,0,0,.244-.859v-.586H8.281a.391.391,0,1,0,0-.781H1.953A1.173,1.173,0,0,1,.781,26.883V24.564a1.164,1.164,0,0,1,.556-1l1.273-.786H17.389l1.273.786a1.164,1.164,0,0,1,.556,1v2.319a1.173,1.173,0,0,1-1.172,1.172H11.7a.391.391,0,1,0,0,.781h2.907v.586a1.63,1.63,0,0,0,.244.859H12.372a.391.391,0,1,0,0,.781h6.984a.391.391,0,1,0,0-.781H17.647a1.63,1.63,0,0,0,.244-.859Zm-15,0H4.609v.586a.859.859,0,1,1-1.719,0ZM.781,22v-.756h.613L1.827,22Zm5.234-8.581a.639.639,0,0,1,.638-.638h6.693a.639.639,0,0,1,.638.638v2.174H6.016ZM7.2,22,9,20.2a.391.391,0,0,0-.552-.552L6.116,21.977,6.1,22H4.607l.942-3.835a.3.3,0,0,1,.29-.227h6.643l-2.38,2.38a.391.391,0,1,0,.552.552l2.932-2.932h.575a.3.3,0,0,1,.289.227L15.393,22Zm9,0-.988-4.022a1.077,1.077,0,0,0-1.048-.822H5.839a1.077,1.077,0,0,0-1.048.822L3.8,22H3l1.034-4.208a1.857,1.857,0,0,1,1.807-1.417h8.323a1.857,1.857,0,0,1,1.807,1.417L17,22Zm1.976,0,.432-.756h.613V22Zm-1.064,7.422a.859.859,0,1,1-1.719,0v-.586h1.719Z"
													transform="translate(0 -12)"
												></path>
											</g>
										</g>
										<g transform="translate(12.548 13.162)">
											<g transform="translate(0 0)">
												<path
													class="a"
													d="M321.612,41.75a.391.391,0,0,0-.391.391v1.23a.391.391,0,0,0,.781,0v-1.23A.391.391,0,0,0,321.612,41.75Z"
													transform="translate(-321.221 -41.75)"
												></path>
											</g>
										</g>
										<g transform="translate(6.681 13.162)">
											<g transform="translate(0 0)">
												<path
													class="a"
													d="M172.309,41.75h-.885a.391.391,0,0,0,0,.781h.052v.84a.391.391,0,0,0,.781,0v-.84h.052a.391.391,0,1,0,0-.781Z"
													transform="translate(-171.033 -41.75)"
												></path>
											</g>
										</g>
										<g transform="translate(10.343 13.162)">
											<g transform="translate(0 0)">
												<path
													class="a"
													d="M266.212,42.775l.321-.384a.391.391,0,0,0-.6-.5l-.23.275-.23-.275a.391.391,0,0,0-.6.5l.321.384-.321.384a.391.391,0,1,0,.6.5l.23-.275.23.275a.391.391,0,1,0,.6-.5Z"
													transform="translate(-264.783 -41.749)"
												></path>
											</g>
										</g>
										<g transform="translate(8.263 13.162)">
											<g transform="translate(0 0)">
												<path
													class="a"
													d="M213.385,43.254l-.553-1.27a.391.391,0,0,0-.716,0l-.553,1.27a.391.391,0,0,0,.716.312l.2-.448.2.448a.391.391,0,1,0,.716-.312Z"
													transform="translate(-211.529 -41.75)"
												></path>
											</g>
										</g>
									</g>
								</svg>
							</span>
							Taxi Book</a
						>
					</li>
					<li class="">
						<a href="#">
							<span class="submenuicon">
								<svg width="20" height="20" viewBox="0 0 20 20">
									<path
										class="a"
										d="M21.684,8.639a.664.664,0,0,0-.649-.029l-1.215.608a1.163,1.163,0,0,0-.986-.551H15.244a2.428,2.428,0,0,0-.379-.932,2.783,2.783,0,0,0,1.118-2.068h1.684V5h-1.35a3.333,3.333,0,0,0-6.65.333A.333.333,0,0,0,10,5.667h.017A2.784,2.784,0,0,0,11.129,7.73a2.578,2.578,0,0,0-.462,1.6V13a1.991,1.991,0,0,0,.549,1.372,4.316,4.316,0,0,0-.549-.039H10V7.667a.333.333,0,0,0-.333-.333H2.333A.333.333,0,0,0,2,7.667V16a.333.333,0,0,0,.333.333H4.354a4.3,4.3,0,0,0-.688,2.333V20A.333.333,0,0,0,4,20.333H6.333a1.667,1.667,0,1,0,3.333,0H18a1.667,1.667,0,1,0,3.333,0h.333A.333.333,0,0,0,22,20V16.667a2.335,2.335,0,0,0-2-2.307V10.206l1.035.518a.667.667,0,0,0,.965-.6V9.206a.662.662,0,0,0-.316-.567Zm-10.35,4.028h3.333A.333.333,0,0,0,15,13a3,3,0,0,1,3,3v1H16.667v-.667a2,2,0,0,0-2-2h-2A1.335,1.335,0,0,1,11.333,13Zm5.333,5h1.576a2.85,2.85,0,0,1,1.009,1H16.667Zm2-.521V16a3.672,3.672,0,0,0-3.333-3.652V11h3.5a1.155,1.155,0,0,0,.5-.117v6.792A4.245,4.245,0,0,0,18.667,17.146Zm-3.7-7.813h3.865a.5.5,0,1,1,0,1H15a.333.333,0,0,0-.333.333V12H11.333V9.333A1.794,1.794,0,0,1,11.792,8H14.2a1.781,1.781,0,0,1,.44,1.056A.333.333,0,0,0,14.969,9.333ZM13,2.667A2.671,2.671,0,0,1,15.646,5H10.354A2.671,2.671,0,0,1,13,2.667Zm-2.315,3h4.63a2.056,2.056,0,0,1-1.071,1.667H11.756A2.057,2.057,0,0,1,10.685,5.667ZM8.8,14.333l.52-1.561A.333.333,0,0,0,9,12.333H8.8l.52-1.561A.333.333,0,0,0,9,10.333H3a.334.334,0,0,0-.316.439l.52,1.561H3a.334.334,0,0,0-.316.439l.52,1.561H2.667v-5H9.333v5ZM3.462,11h2.2v.667h.667V11h2.2l-.445,1.333H3.907Zm0,2h2.2v.667h.667V13h2.2l-.444,1.333H3.907ZM9.333,8v.667H2.667V8ZM2.667,15.667V15H5.7a4.358,4.358,0,0,0-.821.667ZM8,21.333a1,1,0,0,1-1-1H9A1,1,0,0,1,8,21.333ZM5.667,19.667v-.333a3,3,0,1,1,6,0v.333Zm8.667,0h-2v-.333a3.667,3.667,0,1,0-7.333,0v.333H4.333v-1A3.671,3.671,0,0,1,8,15h2.667a3.671,3.671,0,0,1,3.667,3.667ZM12.966,15h1.7A1.335,1.335,0,0,1,16,16.333v2.333H15A4.33,4.33,0,0,0,12.966,15ZM15,19.667v-.333h4.333v.333Zm4.667,1.667a1,1,0,0,1-1-1h2A1,1,0,0,1,19.667,21.333Zm1.667-4.667v3H20V15.034A1.67,1.67,0,0,1,21.333,16.667Zm0-6.539-.921-.461.921-.461Z"
										transform="translate(-2 -2)"
									></path>
								</svg>
							</span>
							Food Delivery</a
						>
					</li>
					<li>
						<a href="#" class="">
							<span class="submenuicon">
								<svg width="16.774" height="20" viewBox="0 0 16.774 20">
									<g transform="translate(-6 -1)">
										<path
											class="a"
											d="M48.323,12.968a.323.323,0,1,0,0,.645h.645v.645a.323.323,0,1,0,.645,0v-.645h.645a.323.323,0,1,0,0-.645h-.645v-.645a.323.323,0,1,0-.645,0v.645Z"
											transform="translate(-28.452 -7.452)"
										></path>
										<path
											class="a"
											d="M18.968,11.29a.323.323,0,1,0,.645,0A1.29,1.29,0,0,0,18.323,10a.323.323,0,0,0,0,.645A.645.645,0,0,1,18.968,11.29Z"
											transform="translate(-8.129 -6.097)"
										></path>
										<path
											class="a"
											d="M38.258,5.516A2.258,2.258,0,1,0,36,3.258a2.258,2.258,0,0,0,2.258,2.258Zm0-3.871a1.613,1.613,0,1,1-1.613,1.613A1.613,1.613,0,0,1,38.258,1.645Z"
											transform="translate(-20.323)"
										></path>
										<path
											class="a"
											d="M42.323,4.645a.645.645,0,0,1,.645.645.323.323,0,1,0,.645,0A1.29,1.29,0,0,0,42.323,4a.323.323,0,0,0,0,.645Z"
											transform="translate(-24.387 -2.032)"
										></path>
										<path
											class="a"
											d="M29.29,12.581A1.29,1.29,0,1,0,28,11.29,1.29,1.29,0,0,0,29.29,12.581Zm0-1.935a.645.645,0,1,1-.645.645A.645.645,0,0,1,29.29,10.645Z"
											transform="translate(-14.903 -6.097)"
										></path>
										<path
											class="a"
											d="M28.129,41H22.323a.323.323,0,0,0-.323.323v1.935a.323.323,0,0,0,.323.323h5.806a.323.323,0,0,0,.323-.323V41.323A.323.323,0,0,0,28.129,41Zm-.323,1.935H22.645v-1.29h5.161Z"
											transform="translate(-10.839 -27.097)"
										></path>
										<path
											class="a"
											d="M13.29,41a1.29,1.29,0,1,0,1.29,1.29A1.29,1.29,0,0,0,13.29,41Zm0,1.935a.645.645,0,1,1,.645-.645A.645.645,0,0,1,13.29,42.935Z"
											transform="translate(-4.065 -27.097)"
										></path>
										<path
											class="a"
											d="M44,42.29A1.29,1.29,0,1,0,45.29,41,1.29,1.29,0,0,0,44,42.29Zm1.935,0a.645.645,0,1,1-.645-.645A.645.645,0,0,1,45.935,42.29Z"
											transform="translate(-25.742 -27.097)"
										></path>
										<path
											class="a"
											d="M21.161,16.672h1.29a.323.323,0,0,0,.323-.323v-1.29a.323.323,0,0,0-.323-.323h-1.29a.323.323,0,0,0-.323.323v.323h-.587l-.527-3.169a1.606,1.606,0,0,0-1.592-1.347h-.2a.968.968,0,1,0-1.935,0H11.771a2.258,2.258,0,1,0-2.312.52,1.6,1.6,0,0,0-.409.827l-.527,3.169H7.935v-.323a.323.323,0,0,0-.323-.323H6.323A.323.323,0,0,0,6,15.059v1.29a.323.323,0,0,0,.323.323h1.29a.323.323,0,0,0,.323-.323v-.323h.479l-.11.662c-.841.083-1.337.543-1.337,1.273v2.9H6.323A.323.323,0,0,0,6,21.188V22.8a.323.323,0,0,0,.323.323H7.29v.968a.968.968,0,0,0,.968.968H8.9a.968.968,0,0,0,.968-.968v-.968H18.9v.968a.968.968,0,0,0,.968.968h.645a.968.968,0,0,0,.968-.968v-.968h.968a.323.323,0,0,0,.323-.323V21.188a.323.323,0,0,0-.323-.323h-.645v-2.9c0-.73-.5-1.191-1.337-1.273l-.11-.662h.479v.323A.323.323,0,0,0,21.161,16.672Zm.323-1.29h.645v.645h-.645ZM7.29,16.027H6.645v-.645H7.29Zm9.677-5.484a.323.323,0,1,1-.323.323A.323.323,0,0,1,16.968,10.543Zm-.716.968a.956.956,0,0,0,1.432,0h.448a.965.965,0,0,1,.914.645H9.728a.964.964,0,0,1,.914-.645ZM8.581,9.253a1.613,1.613,0,1,1,1.613,1.613A1.613,1.613,0,0,1,8.581,9.253ZM9.606,12.8h9.563l.645,3.871h-.939a1.935,1.935,0,1,0-3.813,0h-6.1Zm6.117,3.871a1.29,1.29,0,1,1,2.489,0Zm-6.5,7.419a.323.323,0,0,1-.323.323H8.258a.323.323,0,0,1-.323-.323v-.968h1.29ZM6.645,22.478v-.968h5.484v.968Zm6.129,0v-.968h3.548v.968Zm8.065,1.613a.323.323,0,0,1-.323.323h-.645a.323.323,0,0,1-.323-.323v-.968h1.29Zm1.29-1.613H16.968v-.968h5.161Zm-.968-4.516v2.9H7.613v-2.9c0-.16,0-.645.968-.645H20.194C21.161,17.317,21.161,17.8,21.161,17.962Z"
											transform="translate(0 -4.059)"
										></path>
										<path
											class="a"
											d="M8.323,4.29h.323v.323a.323.323,0,1,0,.645,0V4.29h.323a.323.323,0,1,0,0-.645H9.29V3.323a.323.323,0,1,0-.645,0v.323H8.323a.323.323,0,0,0,0,.645Z"
											transform="translate(-1.355 -1.355)"
										></path>
									</g>
								</svg>
							</span>
							Car Wash</a
						>
					</li>
				</ul>
			</div>
			<div class="col-3">
				<span class="a-t px-4 py-2 cc-h fxt-srvs-header">
					<svg
						enable-background="new 0 0 64 64"
						height="512"
						viewBox="0 0 64 64"
						width="512"
					>
						<path d="m35 45h2v2h-2z"></path>
						<path d="m27 45h2v2h-2z"></path>
						<path d="m31 45h2v2h-2z"></path>
						<path
							d="m32 19c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10-4.486-10-10-10zm0 18c-.313 0-.983-1.023-1.462-3h2.924c-.479 1.977-1.149 3-1.462 3zm-1.819-5c-.077-.614-.134-1.277-.161-2h3.962c-.027.723-.085 1.386-.161 2zm1.819-11c.313 0 .983 1.023 1.462 3h-2.924c.479-1.977 1.149-3 1.462-3zm1.819 5c.077.614.134 1.277.161 2h-3.962c.027-.723.085-1.386.161-2zm-5.8 2h-3.95c.088-.698.263-1.369.52-2h3.579c-.074.657-.125 1.327-.149 2zm-3.95 2h3.95c.024.673.075 1.343.149 2h-3.579c-.256-.631-.432-1.302-.52-2zm11.912 0h3.95c-.088.698-.263 1.369-.52 2h-3.579c.074-.657.125-1.327.149-2zm0-2c-.024-.673-.075-1.343-.149-2h3.579c.256.631.432 1.302.52 2zm2.254-4h-2.719c-.192-.919-.44-1.771-.752-2.498 1.373.508 2.57 1.377 3.471 2.498zm-8.999-2.498c-.312.727-.56 1.579-.752 2.498h-2.719c.901-1.121 2.098-1.99 3.471-2.498zm-3.471 12.498h2.719c.192.919.44 1.771.752 2.498-1.373-.508-2.57-1.377-3.471-2.498zm8.999 2.498c.312-.727.56-1.579.752-2.498h2.719c-.901 1.121-2.098 1.99-3.471 2.498z"
						></path>
						<path
							d="m63 15.764v-5.527l-2.625-.718c-.086-.229-.181-.457-.286-.684l1.35-2.367-3.908-3.907-2.365 1.351c-.226-.104-.455-.2-.685-.286l-.718-2.626h-5.526l-.718 2.625c-.23.086-.459.182-.685.286l-2.365-1.351-3.908 3.907 1.35 2.367c-.104.227-.2.455-.286.684l-2.625.718v.764h-14v-10h-24v20h4v11.522c-2.41 1.616-4 4.364-4 7.478v.193c0 2.036.7 4.032 1.972 5.623l2.028 2.535v1.649c0 2.757 2.243 5 5 5 2.414 0 4.434-1.721 4.899-4h6.82l-1.5 6h-3.219c-1.654 0-3 1.346-3 3v3h36v-3c0-1.654-1.346-3-3-3h-3.219l-1.5-6h11.719c2.414 0 4.434-1.721 4.899-4h1.101c1.654 0 3-1.346 3-3v-8c0-1.654-1.346-3-3-3h-1v-11.029l2.439-2.439-1.35-2.367c.104-.227.2-.455.286-.684zm-10 15.822-1.879-1.88c-.45-.448-1.072-.706-1.707-.706-1.331 0-2.414 1.083-2.414 2.414v1.586h-1c-1.654 0-3 1.346-3 3v5h-24.038c.024-.268.038-.537.038-.807v-.193c0-4.625-3.507-8.442-8-8.941v-10.059h14v-4h16.842c.024.055.044.11.069.165l-1.35 2.367 3.908 3.907 2.365-1.351c.226.104.455.2.685.286l.718 2.626h4.763zm-30-13.55-6.352-4.62c.124-.132.242-.27.352-.416l6-8zm-7.6-6.236c-.563.752-1.461 1.2-2.4 1.2s-1.837-.448-2.4-1.199l-6.601-8.801h18.001zm-6.4 1.201c.11.146.228.284.352.416l-6.352 4.619v-13.036zm2.104 1.615c.596.245 1.239.384 1.896.384s1.299-.139 1.896-.384l6.029 4.384h-15.85zm27.896-1.616v2h-14v-2zm-32 8h2v10.059c-.694.077-1.362.24-2 .466zm-2.466 23.566c-.989-1.236-1.534-2.79-1.534-4.373v-.193c0-3.859 3.14-7 7-7s7 3.141 7 7v.193c0 1.583-.545 3.137-1.534 4.373l-1.946 2.434h-2.52v-4.184c1.161-.414 2-1.514 2-2.816 0-1.654-1.346-3-3-3s-3 1.346-3 3c0 1.302.839 2.402 2 2.816v4.184h-2.52zm4.466-4.566c0-.552.449-1 1-1s1 .448 1 1-.449 1-1 1-1-.448-1-1zm1 13c-1.654 0-3-1.346-3-3v-1h6v1c0 1.654-1.346 3-3 3zm38 7v1h-32v-1c0-.552.449-1 1-1h30c.551 0 1 .448 1 1zm-6.281-3h-19.438l1.5-6h16.438zm12.281-8h-39v-.649l2.028-2.534c.674-.843 1.182-1.801 1.515-2.816h24.457v1c0 1.654 1.346 3 3 3h10.816c-.414 1.16-1.514 1.999-2.816 1.999zm7-13v8c0 .552-.449 1-1 1h-14c-.551 0-1-.448-1-1v-8c0-.552.449-1 1-1h3v-3.586c0-.337.467-.531.707-.293l3.879 3.879h6.414c.551 0 1 .448 1 1zm-6-3v-10.842c.055-.024.111-.044.166-.069l1.834 1.047v9.864zm3.807-18.163-.162.524c-.142.459-.334.921-.572 1.371l-.256.485 1.129 1.979-1.75 1.749-1.979-1.13-.486.258c-.445.236-.906.429-1.369.572l-.525.161-.6 2.194h-2.474l-.6-2.193-.525-.161c-.463-.144-.924-.336-1.369-.572l-.486-.258-1.979 1.13-1.75-1.749 1.129-1.979-.256-.485c-.238-.45-.43-.912-.572-1.371l-.162-.524-2.193-.602v-2.473l2.193-.601.162-.524c.142-.459.334-.921.572-1.371l.256-.485-1.129-1.979 1.75-1.749 1.979 1.13.486-.258c.445-.236.906-.429 1.369-.572l.525-.161.6-2.193h2.474l.6 2.193.525.161c.463.144.924.336 1.369.572l.486.258 1.979-1.13 1.75 1.749-1.129 1.979.256.485c.238.45.43.912.572 1.371l.162.524 2.193.602v2.473z"
						></path>
						<path
							d="m51 7c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zm0 10c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z"
						></path>
						<path d="m47 41h8v2h-8z"></path>
						<path d="m57 41h2v2h-2z"></path>
						<path d="m47 37h12v2h-12z"></path>
					</svg>
					<h5 class="px-2">Industry Solutions</h5>
				</span>
				<ul class="serv-ul">
					<li>
						<a href="#" class="">
							<span class="submenuicon">
								<svg width="20" height="18" viewBox="0 0 20 18">
									<g transform="translate(0 -24)">
										<g transform="translate(0 24)">
											<path
												class="a"
												d="M19.667,41.333h-2V29a.333.333,0,0,0-.333-.333H11.667V24.333A.333.333,0,0,0,11.333,24H2.667a.333.333,0,0,0-.333.333v17h-2a.333.333,0,1,0,0,.667H19.667a.333.333,0,1,0,0-.667Zm-8.667,0H3V24.667h8Zm6,0H11.667v-12H17Z"
												transform="translate(0 -24)"
											></path>
											<path
												class="a"
												d="M312.333,170.667h2a.333.333,0,0,0,.333-.333v-2a.333.333,0,0,0-.333-.333h-2a.333.333,0,0,0-.333.333v2A.333.333,0,0,0,312.333,170.667Zm.333-2H314V170h-1.333Z"
												transform="translate(-299 -162)"
											></path>
											<path
												class="a"
												d="M312.333,250.667h2a.333.333,0,0,0,.333-.333v-2a.333.333,0,0,0-.333-.333h-2a.333.333,0,0,0-.333.333v2A.333.333,0,0,0,312.333,250.667Zm.333-2H314V250h-1.333Z"
												transform="translate(-299 -238.667)"
											></path>
											<path
												class="a"
												d="M312.333,330.667h2a.333.333,0,0,0,.333-.333v-2a.333.333,0,0,0-.333-.333h-2a.333.333,0,0,0-.333.333v2A.333.333,0,0,0,312.333,330.667Zm.333-2H314V330h-1.333Z"
												transform="translate(-299 -315.333)"
											></path>
											<path
												class="a"
												d="M176.333,170.667h2a.333.333,0,0,0,.333-.333v-2a.333.333,0,0,0-.333-.333h-2a.333.333,0,0,0-.333.333v2A.333.333,0,0,0,176.333,170.667Zm.333-2H178V170h-1.333Z"
												transform="translate(-168.667 -162)"
											></path>
											<path
												class="a"
												d="M176.333,90.667h2a.333.333,0,0,0,.333-.333v-2a.333.333,0,0,0-.333-.333h-2a.333.333,0,0,0-.333.333v2A.333.333,0,0,0,176.333,90.667Zm.333-2H178V90h-1.333Z"
												transform="translate(-168.667 -85.333)"
											></path>
											<path
												class="a"
												d="M176.333,250.667h2a.333.333,0,0,0,.333-.333v-2a.333.333,0,0,0-.333-.333h-2a.333.333,0,0,0-.333.333v2A.333.333,0,0,0,176.333,250.667Zm.333-2H178V250h-1.333Z"
												transform="translate(-168.667 -238.667)"
											></path>
											<path
												class="a"
												d="M176.333,330.667h2a.333.333,0,0,0,.333-.333v-2a.333.333,0,0,0-.333-.333h-2a.333.333,0,0,0-.333.333v2A.333.333,0,0,0,176.333,330.667Zm.333-2H178V330h-1.333Z"
												transform="translate(-168.667 -315.333)"
											></path>
											<path
												class="a"
												d="M96.333,170.667h2a.333.333,0,0,0,.333-.333v-2a.333.333,0,0,0-.333-.333h-2a.333.333,0,0,0-.333.333v2A.333.333,0,0,0,96.333,170.667Zm.333-2H98V170H96.667Z"
												transform="translate(-92 -162)"
											></path>
											<path
												class="a"
												d="M96.333,90.667h2a.333.333,0,0,0,.333-.333v-2A.333.333,0,0,0,98.333,88h-2a.333.333,0,0,0-.333.333v2A.333.333,0,0,0,96.333,90.667Zm.333-2H98V90H96.667Z"
												transform="translate(-92 -85.333)"
											></path>
											<path
												class="a"
												d="M96.333,250.667h2a.333.333,0,0,0,.333-.333v-2a.333.333,0,0,0-.333-.333h-2a.333.333,0,0,0-.333.333v2A.333.333,0,0,0,96.333,250.667Zm.333-2H98V250H96.667Z"
												transform="translate(-92 -238.667)"
											></path>
											<path
												class="a"
												d="M96.333,330.667h2a.333.333,0,0,0,.333-.333v-2a.333.333,0,0,0-.333-.333h-2a.333.333,0,0,0-.333.333v2A.333.333,0,0,0,96.333,330.667Zm.333-2H98V330H96.667Z"
												transform="translate(-92 -315.333)"
											></path>
										</g>
									</g>
								</svg>
							</span>
							Real Estate</a
						>
					</li>
					<li class="">
						<a href="#">
							<span class="submenuicon">
								<svg width="20" height="20" viewBox="0 0 20 20">
									<g transform="translate(-2 -1.998)">
										<path
											class="a"
											d="M21.666,2h-10a.333.333,0,0,0-.333.333V6.667H3.667A1.667,1.667,0,0,0,2,8.333V17a1.667,1.667,0,0,0,1.667,1.667h4V20H7.333a1,1,0,0,0-1,1v.667A.333.333,0,0,0,6.667,22h6A.333.333,0,0,0,13,21.666V21a1,1,0,0,0-1-1h-.333V18.666h4A1.667,1.667,0,0,0,17.333,17V10.666h4.333A.333.333,0,0,0,22,10.333v-8A.333.333,0,0,0,21.666,2ZM12,20.666a.333.333,0,0,1,.333.333v.333H7V21a.333.333,0,0,1,.333-.333ZM8.333,20V18.666H11V20Zm8.333-3a1,1,0,0,1-1,1h-12a1,1,0,0,1-1-1v-.333h14Zm0-1h-14V8.333a1,1,0,0,1,1-1h7.666v3a.333.333,0,0,0,.333.333h5Zm4.667-6H12V2.667h9.333Z"
											transform="translate(0 -0.001)"
										></path>
										<path
											class="a"
											d="M9.667,20a3.667,3.667,0,1,0,3.667,3.667A3.667,3.667,0,0,0,9.667,20Zm0,6.666a3,3,0,1,1,3-3A3,3,0,0,1,9.667,26.666Z"
											transform="translate(-2.667 -12.001)"
										></path>
										<path
											class="a"
											d="M15,26a.333.333,0,0,1,.333.333H16a1,1,0,0,0-.667-.939V25h-.667v.395A1,1,0,0,0,15,27.333a.333.333,0,1,1-.333.333H14a1,1,0,0,0,.667.939V29h.667v-.395A1,1,0,0,0,15,26.667.333.333,0,0,1,15,26Z"
											transform="translate(-8 -15.335)"
										></path>
										<path
											class="a"
											d="M53.922,32.13l-1.667-2a.344.344,0,0,0-.513,0l-1.667,2a.333.333,0,0,0,.257.547H51v7.666a.333.333,0,0,0,.333.333h1.333A.333.333,0,0,0,53,40.343V32.677h.667a.333.333,0,0,0,.257-.547Zm-1.257-.12a.333.333,0,0,0-.333.333V40.01h-.667V32.343a.333.333,0,0,0-.333-.333h-.29L52,30.863l.957,1.147Z"
											transform="translate(-31.999 -18.678)"
										></path>
										<path
											class="a"
											d="M10.546,3.742l-2-1.667A.333.333,0,0,0,8,2.332V3H2.333A.333.333,0,0,0,2,3.332V4.666A.333.333,0,0,0,2.333,5H8v.667a.333.333,0,0,0,.193.3.341.341,0,0,0,.14.03.333.333,0,0,0,.213-.077l2-1.667a.333.333,0,0,0,0-.513Zm-1.88,1.21V4.666a.333.333,0,0,0-.333-.333H2.667V3.666H8.333a.333.333,0,0,0,.333-.333V3.046L9.813,4Z"
											transform="translate(0)"
										></path>
										<path
											class="a"
											d="M35.333,17.333h1.333A.333.333,0,0,0,37,17V14.333A.333.333,0,0,0,36.667,14H35.333a.333.333,0,0,0-.333.333V17A.333.333,0,0,0,35.333,17.333Zm.333-2.667h.667v2h-.667Z"
											transform="translate(-22 -8.001)"
										></path>
										<path
											class="a"
											d="M43.333,14.667h1.333A.333.333,0,0,0,45,14.333v-4A.333.333,0,0,0,44.667,10H43.333a.333.333,0,0,0-.333.333v4A.333.333,0,0,0,43.333,14.667Zm.333-4h.667V14h-.667Z"
											transform="translate(-27.334 -5.334)"
										></path>
										<path
											class="a"
											d="M51.333,12h1.333A.333.333,0,0,0,53,11.667V6.333A.333.333,0,0,0,52.667,6H51.333A.333.333,0,0,0,51,6.333v5.333A.333.333,0,0,0,51.333,12Zm.333-5.333h.667v4.667h-.667Z"
											transform="translate(-32.667 -2.668)"
										></path>
										<path
											class="a"
											d="M30,30h1.333v.667H30Z"
											transform="translate(-18.667 -18.668)"
										></path>
										<path
											class="a"
											d="M36,30h2v.667H36Z"
											transform="translate(-22.667 -18.668)"
										></path>
										<path
											class="a"
											d="M30,34h1.333v.667H30Z"
											transform="translate(-18.667 -21.335)"
										></path>
										<path
											class="a"
											d="M36,34h2v.667H36Z"
											transform="translate(-22.667 -21.335)"
										></path>
										<path
											class="a"
											d="M30,38h1.333v.667H30Z"
											transform="translate(-18.667 -24.001)"
										></path>
										<path
											class="a"
											d="M36,38h2v.667H36Z"
											transform="translate(-22.667 -24.001)"
										></path>
									</g>
								</svg>
							</span>
							Banking and Finance</a
						>
					</li>
					<li>
						<a href="#">
							<span class="submenuicon">
								<svg width="20" height="20" viewBox="0 0 20 20">
									<g transform="translate(0)">
										<path
											class="a"
											d="M18.843,11.406H16.719v-.7a1.173,1.173,0,0,0-1.172-1.172H13.516A1.173,1.173,0,0,0,12.344,10.7v.7h-.937v-4.3A1.955,1.955,0,0,0,9.453,5.156H8.438V1.172A1.173,1.173,0,0,0,7.266,0H4.141A1.173,1.173,0,0,0,2.969,1.172V5.156H1.953A1.955,1.955,0,0,0,0,7.109v2.93a.391.391,0,0,0,.781,0V7.109A1.173,1.173,0,0,1,1.953,5.938h7.5a1.173,1.173,0,0,1,1.172,1.172v4.3h-.406a1.158,1.158,0,0,0-1.157,1.157v5.093H1.953A1.173,1.173,0,0,1,.781,16.484v-2.93a.391.391,0,0,0-.781,0v2.93A1.956,1.956,0,0,0,1.563,18.4v.43a1.172,1.172,0,0,0,2.344,0v-.391H7.5v.391a1.171,1.171,0,0,0,1.948.877,1.152,1.152,0,0,0,.771.3h8.624A1.158,1.158,0,0,0,20,18.843v-6.28A1.158,1.158,0,0,0,18.843,11.406ZM4.141.781H7.266a.391.391,0,0,1,.391.391v.391H3.75V1.172A.391.391,0,0,1,4.141.781ZM3.75,5.156V2.344H7.656V5.156Zm15.469,7.407v.7a1.519,1.519,0,0,1-1.072-1.072h.7A.376.376,0,0,1,19.219,12.563Zm0,4.785A2.3,2.3,0,0,0,17.5,18.706v-6a2.3,2.3,0,0,0,1.719,1.358ZM9.844,14.059A2.3,2.3,0,0,0,11.563,12.7v6a2.3,2.3,0,0,0-1.719-1.358Zm2.5-1.871h4.375v7.031H12.344Zm.781-1.484a.391.391,0,0,1,.391-.391h2.031a.391.391,0,0,1,.391.391v.7H13.125Zm-2.906,1.484h.7a1.519,1.519,0,0,1-1.072,1.072v-.7A.376.376,0,0,1,10.219,12.187ZM3.125,18.828a.391.391,0,0,1-.781,0v-.391h.781Zm5.547.391a.391.391,0,0,1-.391-.391v-.391h.781v.391A.391.391,0,0,1,8.672,19.219Zm1.172-.375v-.7a1.519,1.519,0,0,1,1.072,1.072h-.7A.376.376,0,0,1,9.844,18.843Zm9,.375h-.7a1.519,1.519,0,0,1,1.072-1.072v.7A.376.376,0,0,1,18.843,19.219Z"
											transform="translate(0)"
										></path>
										<path
											class="a"
											d="M55.589,237.333a1.589,1.589,0,1,0,1.589,1.589,1.59,1.59,0,0,0-1.589-1.589Zm0,2.4a.807.807,0,1,1,.807-.807A.808.808,0,0,1,55.589,239.729Z"
											transform="translate(-51.891 -228.062)"
										></path>
										<path
											class="a"
											d="M101.478,329.062a.756.756,0,0,0-.662.382l-1.044,1.809a.764.764,0,0,0,.662,1.146h2.089a.764.764,0,0,0,.662-1.146l-1.044-1.809A.756.756,0,0,0,101.478,329.062Zm-1.015,2.556,1.015-1.758,1.015,1.758Z"
											transform="translate(-95.775 -316.208)"
										></path>
										<path
											class="a"
											d="M169.526,199.055a.391.391,0,0,0,.391-.391v-2.135a.391.391,0,0,0-.391-.391h-2.135a.391.391,0,0,0-.391.391v2.135a.391.391,0,0,0,.391.391Zm-1.745-2.135h1.354v1.354h-1.354Z"
											transform="translate(-160.477 -188.476)"
										></path>
										<path
											class="a"
											d="M.391,292.781a.391.391,0,1,0-.276-.667.391.391,0,0,0,.276.667Z"
											transform="translate(0 -280.594)"
										></path>
									</g>
								</svg>
							</span>
							Travel and Tourism</a
						>
					</li>
					<li>
						<a href="#">
							<span class="submenuicon">
								<svg width="20" height="19.749" viewBox="0 0 20 19.749">
									<g transform="translate(0 -3.215)">
										<path
											class="a"
											d="M190.488,33.334a.327.327,0,1,0-.327-.327A.327.327,0,0,0,190.488,33.334Z"
											transform="translate(-182.733 -28.313)"
										></path>
										<path
											class="a"
											d="M141.148,77.481h3.921a.293.293,0,0,0,0-.586h-3.921a.293.293,0,0,0,0,.586Z"
											transform="translate(-135.353 -70.802)"
										></path>
										<path
											class="a"
											d="M290.2,366.267v.561a.293.293,0,0,0,.586,0v-.561a.293.293,0,0,0-.586,0Z"
											transform="translate(-278.868 -348.589)"
										></path>
										<path
											class="a"
											d="M439.787,366.267v.561a.293.293,0,0,0,.586,0v-.561a.293.293,0,0,0-.586,0Z"
											transform="translate(-422.608 -348.589)"
										></path>
										<path
											class="a"
											d="M346.889,380.018a.728.728,0,0,1-1.1,0,.293.293,0,1,0-.442.385,1.314,1.314,0,0,0,1.982,0,.293.293,0,0,0-.442-.385Z"
											transform="translate(-331.789 -361.987)"
										></path>
										<path
											class="a"
											d="M106.343,180.44l1.644-.843a.293.293,0,1,0-.267-.521l-1.217.624v-.363a.293.293,0,0,0-.586,0v.843A.293.293,0,0,0,106.343,180.44Z"
											transform="translate(-101.779 -168.96)"
										></path>
										<path
											class="a"
											d="M187.554,190.423h2.587a.293.293,0,1,0,0-.586h-2.587a.293.293,0,0,0,0,.586Z"
											transform="translate(-179.946 -179.332)"
										></path>
										<path
											class="a"
											d="M106.343,249.037l1.644-.843a.293.293,0,0,0-.267-.521l-1.217.624v-.364a.293.293,0,0,0-.586,0v.843A.293.293,0,0,0,106.343,249.037Z"
											transform="translate(-101.779 -234.877)"
										></path>
										<path
											class="a"
											d="M187.554,259.02h2.587a.293.293,0,1,0,0-.586h-2.587a.293.293,0,0,0,0,.586Z"
											transform="translate(-179.946 -245.249)"
										></path>
										<path
											class="a"
											d="M106.209,317.665c.127,0,.04,0,1.778-.875a.293.293,0,1,0-.267-.521l-1.217.624v-.364a.293.293,0,1,0-.586,0v.843a.293.293,0,0,0,.293.293Z"
											transform="translate(-101.779 -300.793)"
										></path>
										<path
											class="a"
											d="M2.669,22.514H11.66a2.986,2.986,0,0,0,2.891.144,3,3,0,0,0,3.167-.334,6.186,6.186,0,0,0,1.384-1.48.293.293,0,0,0-.489-.323,5.6,5.6,0,0,1-1.254,1.339,2.407,2.407,0,0,1-2.627.23.375.375,0,0,0-.36,0l-.034.018a2.443,2.443,0,0,1-2.432-.133,3.371,3.371,0,0,1-.326-.247c-3.66-3.047-1.644-8.747,2.858-6.845.168.071.213-.02.7-.175,3.248-1.032,5.03,2.043,3.975,4.834a.293.293,0,1,0,.548.207c.881-2.329,0-4.949-2.137-5.652a2.419,2.419,0,0,0,.039-2.031.293.293,0,0,0-.14-.14,2.374,2.374,0,0,0-1.913-.014V7.929A2.672,2.672,0,0,0,12.842,5.26h-.779a1.26,1.26,0,0,0-1.173-.8H9.326a1.613,1.613,0,0,0-3.14,0H4.622a1.26,1.26,0,0,0-1.173.8H2.669A2.672,2.672,0,0,0,0,7.929V19.845a2.672,2.672,0,0,0,2.669,2.669Zm12.075-8.291c-.041.015-.131.048-.193.073a4.606,4.606,0,0,0-2.392-.342,1.883,1.883,0,0,1-.134-1.54,2.157,2.157,0,0,1,2.719,1.809Zm2.333-1.809a1.881,1.881,0,0,1-.135,1.543,4.2,4.2,0,0,0-1.63.094,2.757,2.757,0,0,0-.393-1.023A2.026,2.026,0,0,1,17.077,12.414ZM14.925,7.929V12.24a3.031,3.031,0,0,0-.375.324,2.867,2.867,0,0,0-.981-.66V8.1a.875.875,0,0,0-.874-.874h-.566a1.26,1.26,0,0,0,.019-.215V5.846h.694A2.086,2.086,0,0,1,14.925,7.929ZM4.622,5.042H6.438a.293.293,0,0,0,.293-.276,1.027,1.027,0,0,1,2.05,0,.293.293,0,0,0,.293.276H10.89a.674.674,0,0,1,.672.672c0,1.345.041,1.442-.117,1.675a.679.679,0,0,1-.555.294c-6.663,0-6.3.008-6.4-.014a.674.674,0,0,1-.537-.659c0-1.412,0-1.305.007-1.386a.673.673,0,0,1,.666-.583ZM.586,7.929A2.086,2.086,0,0,1,2.669,5.846h.694V7.011a1.259,1.259,0,0,0,.019.215H2.816a.875.875,0,0,0-.874.874v3.52a.293.293,0,1,0,.586,0V8.1a.288.288,0,0,1,.288-.288h.836a1.253,1.253,0,0,0,.97.457c6.787,0,6.352.017,6.584-.04a1.247,1.247,0,0,0,.654-.417H12.7a.288.288,0,0,1,.288.288v3.644a2.288,2.288,0,0,0-1.227.146.354.354,0,0,0-.22.176,2.417,2.417,0,0,0,.038,2.029,3.479,3.479,0,0,0-2,1.769H7.608a.293.293,0,1,0,0,.586h1.72c0,.015-.032.1-.046.148h0a5.039,5.039,0,0,0,.242,3.363H2.816a.288.288,0,0,1-.288-.288v-6.88a.293.293,0,1,0-.586,0v6.88a.875.875,0,0,0,.874.874h7a5.929,5.929,0,0,0,1.1,1.381H2.669A2.086,2.086,0,0,1,.586,19.845Z"
											transform="translate(0)"
										></path>
									</g>
								</svg>
							</span>
							Health and Fitness</a
						>
					</li>
				</ul>
			</div>
			<div class="col-3">
				<span class="a-t px-4 py-2 cc-h fxt-srvs-header">
					<svg
						x="0px"
						y="0px"
						viewBox="0 0 512 512"
						style="enable-background: new 0 0 512 512"
						xml:space="preserve"
					>
						<g>
							<g>
								<path
									d="M477.867,102.4c-18.825,0-34.133,15.309-34.133,34.133s15.309,34.133,34.133,34.133S512,155.358,512,136.533
                            C512,117.709,496.691,102.4,477.867,102.4z M477.867,153.6c-9.412,0-17.067-7.654-17.067-17.067
                            c0-9.412,7.654-17.067,17.067-17.067s17.067,7.654,17.067,17.067C494.933,145.946,487.279,153.6,477.867,153.6z"
								></path>
							</g>
						</g>
						<g>
							<g>
								<path
									d="M34.133,384C15.309,384,0,399.309,0,418.133s15.309,34.133,34.133,34.133c18.825,0,34.133-15.309,34.133-34.133
                            S52.958,384,34.133,384z M34.133,435.2c-9.412,0-17.067-7.654-17.067-17.067s7.654-17.067,17.067-17.067
                            c9.412,0,17.067,7.654,17.067,17.067S43.546,435.2,34.133,435.2z"
								></path>
							</g>
						</g>
						<g>
							<g>
								<path
									d="M461.321,113.186l-73.617-35.541c-4.25-2.057-9.344-0.265-11.392,3.977c-2.048,4.241-0.265,9.344,3.977,11.392
                            l73.617,35.541c1.195,0.58,2.458,0.853,3.703,0.853c3.174,0,6.221-1.775,7.688-4.83
                            C467.345,120.337,465.562,115.234,461.321,113.186z"
								></path>
							</g>
						</g>
						<g>
							<g>
								<path
									d="M384,443.733c-18.825,0-34.133,15.309-34.133,34.133S365.175,512,384,512c18.825,0,34.133-15.309,34.133-34.133
                            S402.825,443.733,384,443.733z M384,494.933c-9.412,0-17.067-7.654-17.067-17.067S374.588,460.8,384,460.8
                            c9.412,0,17.067,7.654,17.067,17.067S393.412,494.933,384,494.933z"
								></path>
							</g>
						</g>
						<g>
							<g>
								<path
									d="M367.454,454.52l-73.617-35.541c-4.25-2.057-9.344-0.273-11.392,3.977c-2.048,4.241-0.265,9.344,3.977,11.392
                            l73.617,35.541c1.195,0.58,2.458,0.853,3.703,0.853c3.174,0,6.221-1.775,7.689-4.83
                            C373.478,461.67,371.695,456.568,367.454,454.52z"
								></path>
							</g>
						</g>
						<g>
							<g>
								<path
									d="M256,230.4c-18.825,0-34.133,15.309-34.133,34.133c0,18.825,15.309,34.133,34.133,34.133
                            c18.825,0,34.133-15.309,34.133-34.133C290.133,245.709,274.825,230.4,256,230.4z M256,281.6c-9.412,0-17.067-7.654-17.067-17.067
                            c0-9.412,7.654-17.067,17.067-17.067c9.412,0,17.067,7.654,17.067,17.067C273.067,273.946,265.412,281.6,256,281.6z"
								></path>
							</g>
						</g>
						<g>
							<g>
								<path
									d="M240.998,242.142l-56.55-44.075c-3.721-2.876-9.079-2.236-11.981,1.485c-2.893,3.721-2.236,9.079,1.485,11.981
                            l56.55,44.075c1.562,1.212,3.405,1.801,5.24,1.801c2.543,0,5.052-1.126,6.741-3.285
                            C245.376,250.402,244.719,245.043,240.998,242.142z"
								></path>
							</g>
						</g>
						<g>
							<g>
								<path
									d="M409.6,221.867c-51.755,0-93.867,42.112-93.867,93.867c0,51.755,42.112,93.867,93.867,93.867
                            c51.755,0,93.867-42.112,93.867-93.867C503.467,263.979,461.355,221.867,409.6,221.867z M409.6,392.533
                            c-42.351,0-76.8-34.449-76.8-76.8s34.449-76.8,76.8-76.8s76.8,34.449,76.8,76.8S451.951,392.533,409.6,392.533z"
								></path>
							</g>
						</g>
						<g>
							<g>
								<path
									d="M409.6,256c-18.825,0-34.133,15.309-34.133,34.133c0,18.825,15.309,34.133,34.133,34.133
                            c18.825,0,34.133-15.309,34.133-34.133S428.425,256,409.6,256z M409.6,307.2c-9.412,0-17.067-7.654-17.067-17.067
                            c0-9.412,7.654-17.067,17.067-17.067c9.412,0,17.067,7.654,17.067,17.067C426.667,299.546,419.012,307.2,409.6,307.2z"
								></path>
							</g>
						</g>
						<g>
							<g>
								<path
									d="M434.355,341.333h-49.51c-14.583,0-26.445,11.546-26.445,25.728v22.494c0,3.046,1.621,5.862,4.258,7.39
                            C376.96,405.222,393.19,409.6,409.6,409.6s32.64-4.378,46.942-12.655c2.637-1.519,4.258-4.344,4.258-7.381V367.07
                            C460.8,352.879,448.939,341.333,434.355,341.333z M443.733,384.469c-21.239,10.581-47.027,10.581-68.267,0V367.07
                            c0-4.779,4.207-8.67,9.378-8.67h49.51c5.171,0,9.378,3.891,9.378,8.67V384.469z"
								></path>
							</g>
						</g>
						<g>
							<g>
								<path
									d="M204.8,324.267c-51.755,0-93.867,42.112-93.867,93.867S153.045,512,204.8,512c51.755,0,93.867-42.112,93.867-93.867
                            S256.555,324.267,204.8,324.267z M204.8,494.933c-42.351,0-76.8-34.449-76.8-76.8s34.449-76.8,76.8-76.8
                            c42.351,0,76.8,34.449,76.8,76.8S247.151,494.933,204.8,494.933z"
								></path>
							</g>
						</g>
						<g>
							<g>
								<path
									d="M204.8,358.4c-18.825,0-34.133,15.309-34.133,34.133c0,18.825,15.309,34.133,34.133,34.133s34.133-15.309,34.133-34.133
                            C238.933,373.709,223.625,358.4,204.8,358.4z M204.8,409.6c-9.412,0-17.067-7.654-17.067-17.067
                            c0-9.412,7.654-17.067,17.067-17.067c9.412,0,17.067,7.654,17.067,17.067C221.867,401.946,214.212,409.6,204.8,409.6z"
								></path>
							</g>
						</g>
						<g>
							<g>
								<path
									d="M229.555,443.733h-49.51c-14.583,0-26.445,11.546-26.445,25.728v22.494c0,3.046,1.621,5.862,4.258,7.39
                            C172.16,507.622,188.39,512,204.8,512s32.64-4.378,46.942-12.655c2.637-1.519,4.258-4.343,4.258-7.381V469.47
                            C256,455.279,244.139,443.733,229.555,443.733z M238.933,486.869c-21.24,10.581-47.027,10.581-68.267,0V469.47
                            c0-4.779,4.207-8.67,9.378-8.67h49.51c5.171,0,9.378,3.891,9.378,8.67V486.869z"
								></path>
							</g>
						</g>
						<g>
							<g>
								<path
									d="M93.867,110.933C42.112,110.933,0,153.045,0,204.8c0,51.755,42.112,93.867,93.867,93.867
                            c51.755,0,93.867-42.112,93.867-93.867C187.733,153.045,145.621,110.933,93.867,110.933z M93.867,281.6
                            c-42.351,0-76.8-34.449-76.8-76.8c0-42.351,34.449-76.8,76.8-76.8c42.351,0,76.8,34.449,76.8,76.8
                            C170.667,247.151,136.218,281.6,93.867,281.6z"
								></path>
							</g>
						</g>
						<g>
							<g>
								<path
									d="M93.867,145.067c-18.825,0-34.133,15.309-34.133,34.133s15.309,34.133,34.133,34.133
                            c18.825,0,34.133-15.309,34.133-34.133S112.691,145.067,93.867,145.067z M93.867,196.267c-9.412,0-17.067-7.654-17.067-17.067
                            s7.654-17.067,17.067-17.067c9.412,0,17.067,7.654,17.067,17.067S103.279,196.267,93.867,196.267z"
								></path>
							</g>
						</g>
						<g>
							<g>
								<path
									d="M118.622,230.4h-49.51c-14.583,0-26.445,11.546-26.445,25.728v22.494c0,3.046,1.621,5.862,4.258,7.39
                            c14.302,8.277,30.532,12.655,46.942,12.655c16.41,0,32.64-4.378,46.942-12.655c2.637-1.519,4.258-4.344,4.258-7.381v-22.494
                            C145.067,241.946,133.205,230.4,118.622,230.4z M128,273.536c-21.239,10.581-47.027,10.581-68.267,0v-17.399
                            c0-4.779,4.207-8.67,9.378-8.67h49.51c5.171,0,9.378,3.891,9.378,8.67V273.536z"
								></path>
							</g>
						</g>
						<g>
							<g>
								<path
									d="M298.667,0C246.912,0,204.8,42.112,204.8,93.867c0,51.755,42.112,93.867,93.867,93.867
                            c51.755,0,93.867-42.112,93.867-93.867C392.533,42.112,350.421,0,298.667,0z M298.667,170.667c-42.351,0-76.8-34.449-76.8-76.8
                            c0-42.351,34.449-76.8,76.8-76.8s76.8,34.449,76.8,76.8C375.467,136.218,341.018,170.667,298.667,170.667z"
								></path>
							</g>
						</g>
						<g>
							<g>
								<path
									d="M298.667,34.133c-18.825,0-34.133,15.309-34.133,34.133s15.309,34.133,34.133,34.133S332.8,87.091,332.8,68.267
                            S317.491,34.133,298.667,34.133z M298.667,85.333c-9.412,0-17.067-7.654-17.067-17.067c0-9.412,7.654-17.067,17.067-17.067
                            s17.067,7.654,17.067,17.067C315.733,77.679,308.079,85.333,298.667,85.333z"
								></path>
							</g>
						</g>
						<g>
							<g>
								<path
									d="M323.422,119.467h-49.51c-14.583,0-26.445,11.546-26.445,25.728v22.494c0,3.046,1.621,5.862,4.258,7.39
                            c14.302,8.277,30.532,12.655,46.942,12.655s32.64-4.378,46.942-12.655c2.637-1.519,4.258-4.344,4.258-7.381v-22.494
                            C349.867,131.012,338.005,119.467,323.422,119.467z M332.8,162.603c-21.239,10.581-47.027,10.581-68.267,0v-17.399
                            c0-4.779,4.207-8.67,9.378-8.67h49.51c5.171,0,9.378,3.891,9.378,8.67V162.603z"
								></path>
							</g>
						</g>
						<g>
							<g>
								<path
									d="M219.827,88.311c-3.063-3.567-8.448-3.994-12.032-0.93l-59.136,50.603c-3.584,3.063-4.002,8.448-0.939,12.032
                            c1.69,1.971,4.079,2.987,6.485,2.987c1.963,0,3.934-0.674,5.547-2.057l59.136-50.603C222.473,97.28,222.891,91.895,219.827,88.311
                            z"
								></path>
							</g>
						</g>
						<g>
							<g>
								<path
									d="M407.893,225.289l-51.2-68.267c-2.825-3.78-8.175-4.523-11.947-1.707c-3.772,2.825-4.531,8.175-1.707,11.938l51.2,68.267
                            c1.681,2.236,4.241,3.413,6.835,3.413c1.775,0,3.576-0.555,5.112-1.707C409.958,234.402,410.718,229.052,407.893,225.289z"
								></path>
							</g>
						</g>
						<g>
							<g>
								<path
									d="M337.86,343.953c-2.825-3.772-8.175-4.531-11.947-1.707l-47.667,35.746c-3.772,2.825-4.531,8.175-1.707,11.938
                            c1.681,2.236,4.241,3.413,6.835,3.413c1.783,0,3.575-0.563,5.112-1.707l47.667-35.746
                            C339.925,353.067,340.685,347.716,337.86,343.953z"
								></path>
							</g>
						</g>
						<g>
							<g>
								<path
									d="M119.467,409.6H59.733c-4.71,0-8.533,3.814-8.533,8.533s3.823,8.533,8.533,8.533h59.733c4.71,0,8.533-3.814,8.533-8.533
                            S124.177,409.6,119.467,409.6z"
								></path>
							</g>
						</g>
						<g>
							<g>
								<path
									d="M93.867,0C75.042,0,59.733,15.309,59.733,34.133c0,18.825,15.309,34.133,34.133,34.133
                            c18.825,0,34.133-15.309,34.133-34.133C128,15.309,112.691,0,93.867,0z M93.867,51.2c-9.412,0-17.067-7.654-17.067-17.067
                            c0-9.412,7.654-17.067,17.067-17.067c9.412,0,17.067,7.654,17.067,17.067C110.933,43.546,103.279,51.2,93.867,51.2z"
								></path>
							</g>
						</g>
						<g>
							<g>
								<path
									d="M93.867,51.2c-4.71,0-8.533,3.814-8.533,8.533v59.733c0,4.719,3.823,8.533,8.533,8.533c4.71,0,8.533-3.814,8.533-8.533
                            V59.733C102.4,55.014,98.577,51.2,93.867,51.2z"
								></path>
							</g>
						</g>
						<g></g>
						<g></g>
						<g></g>
						<g></g>
						<g></g>
						<g></g>
						<g></g>
						<g></g>
						<g></g>
						<g></g>
						<g></g>
						<g></g>
						<g></g>
						<g></g>
						<g></g>
					</svg>
					<h5 class="px-2">Social Solutions</h5>
				</span>
				<ul class="serv-ul">
					<li>
						<a href="#">
							<span class="submenuicon">
								<svg width="20" height="20" viewBox="0 0 20 20">
									<g transform="translate(6.266 12.808)">
										<path
											class="a"
											d="M161.077,328a.39.39,0,1,0,.115.276A.393.393,0,0,0,161.077,328Z"
											transform="translate(-160.41 -327.89)"
										></path>
									</g>
									<g transform="translate(0 3.811)">
										<path
											class="a"
											d="M20,107.031a1.66,1.66,0,0,0-1.294-1.616,1.656,1.656,0,0,0-1.38-2.573H12.98l.569-1.688a2.636,2.636,0,0,0-1.731-3.363l-.685-.208a.39.39,0,0,0-.481.241L9.574,100.8a3.67,3.67,0,0,1-1.7,1.976L6.8,103.36a1.269,1.269,0,0,0-1.024-.519H.391a.391.391,0,0,0-.391.391v10.131a.391.391,0,0,0,.391.391H5.777a1.27,1.27,0,0,0,1.1-.631l.551.216a5.982,5.982,0,0,0,2.193.415h6.826a1.656,1.656,0,0,0,1.376-2.58,1.655,1.655,0,0,0,.974-2.548A1.66,1.66,0,0,0,20,107.031Zm-1.657.876H14.325a.391.391,0,1,0,0,.781h3.1a.876.876,0,1,1,0,1.751h-3.1a.391.391,0,1,0,0,.781h2.118a.876.876,0,0,1,0,1.751H9.618a5.2,5.2,0,0,1-1.907-.361l-.663-.26v-3.832a.391.391,0,0,0-.781,0v3.964a.489.489,0,0,1-.489.489h-5v-9.35h5a.489.489,0,0,1,.489.489v1.326a.391.391,0,0,0,.781,0v-1.322l1.2-.655a4.45,4.45,0,0,0,2.058-2.4l.951-2.628.331.1a1.855,1.855,0,0,1,1.218,2.366l-.742,2.2a.391.391,0,0,0,.37.515h4.891a.876.876,0,0,1,0,1.751h-3a.391.391,0,1,0,0,.781h4.018a.876.876,0,0,1,0,1.752Z"
											transform="translate(0 -97.564)"
										></path>
									</g>
									<g transform="translate(3.17 16.232)">
										<path
											class="a"
											d="M82.256,415.53a1.094,1.094,0,1,0,1.094,1.094A1.1,1.1,0,0,0,82.256,415.53Zm0,1.407a.313.313,0,1,1,.313-.313A.313.313,0,0,1,82.256,416.937Z"
											transform="translate(-81.162 -415.53)"
										></path>
									</g>
									<g transform="translate(11.282)">
										<path
											class="a"
											d="M289.486.114a.391.391,0,0,0-.667.276.391.391,0,1,0,.667-.276Z"
											transform="translate(-288.819)"
										></path>
									</g>
									<g transform="translate(11.282 1.458)">
										<path
											class="a"
											d="M289.211,37.333a.391.391,0,0,0-.391.391v.951a.391.391,0,0,0,.781,0v-.951A.391.391,0,0,0,289.211,37.333Z"
											transform="translate(-288.82 -37.333)"
										></path>
									</g>
									<g transform="translate(14 5.128)">
										<path
											class="a"
											d="M361.192,131.266h-2.409a.391.391,0,0,0,0,.781h2.409a.391.391,0,1,0,0-.781Z"
											transform="translate(-358.393 -131.266)"
										></path>
									</g>
									<g transform="translate(6.154 5.127)">
										<path
											class="a"
											d="M160.353,131.239h-2.409a.391.391,0,0,0,0,.781h2.409a.391.391,0,0,0,0-.781Z"
											transform="translate(-157.554 -131.239)"
										></path>
									</g>
									<g transform="translate(7.936 1.781)">
										<path
											class="a"
											d="M204.966,46.842,203.829,45.7a.391.391,0,0,0-.552.552l1.137,1.137a.391.391,0,0,0,.552-.552Z"
											transform="translate(-203.162 -45.59)"
										></path>
									</g>
									<g transform="translate(13.49 1.782)">
										<path
											class="a"
											d="M347.157,45.723a.391.391,0,0,0-.552,0l-1.137,1.137a.391.391,0,0,0,.552.552l1.137-1.137A.391.391,0,0,0,347.157,45.723Z"
											transform="translate(-345.353 -45.609)"
										></path>
									</g>
								</svg>
							</span>
							Social Media</a
						>
					</li>
					<li>
						<a href="#">
							<span class="submenuicon">
								<svg width="20" height="18.667" viewBox="0 0 20 18.667" class="">
									<g transform="translate(-16 -48)">
										<path
											class="a"
											d="M34.667,216.667A1.335,1.335,0,0,0,36,215.333v-4A1.335,1.335,0,0,0,34.667,210H33.333v-1.667A.333.333,0,0,0,33,208H19a.333.333,0,0,0-.333.333V210H17.333A1.335,1.335,0,0,0,16,211.333v4a1.335,1.335,0,0,0,1.333,1.333h1.333V218H17a1,1,0,0,0,0,2H35a1,1,0,0,0,0-2H33.333v-1.333Zm0-6a.667.667,0,0,1,.667.667v4a.667.667,0,0,1-.667.667H33.333v-.667h1a.333.333,0,0,0,.333-.333v-3.333a.333.333,0,0,0-.333-.333h-1v-.667Zm-1.333,4V212H34v2.667Zm-7.667,1.2-2.614-2.614a1.317,1.317,0,1,1,1.862-1.862l.752.752Zm.667-3.724.752-.752a1.317,1.317,0,1,1,1.862,1.862l-2.614,2.614Zm-7.667,2.529H18V212h.667ZM17.333,216a.667.667,0,0,1-.667-.667v-4a.667.667,0,0,1,.667-.667h1.333v.667h-1a.333.333,0,0,0-.333.333V215a.333.333,0,0,0,.333.333h1V216Zm2-7.333h6.333V211.2l-.281-.281a1.983,1.983,0,1,0-2.8,2.8l3.086,3.086V218H19.333Zm16,10.333a.334.334,0,0,1-.333.333H17a.333.333,0,0,1,0-.667H35A.334.334,0,0,1,35.333,219Zm-9-1v-1.2l3.086-3.086a1.983,1.983,0,1,0-2.8-2.8l-.281.281v-2.529h6.333V218Z"
											transform="translate(0 -153.333)"
										></path>
										<path
											class="a"
											d="M105.333,50.667h10.333a.667.667,0,1,1,0,1.333h-6.333A1.335,1.335,0,0,0,108,53.333V54h.667v-.667a.667.667,0,0,1,.667-.667h2.846a1.325,1.325,0,0,0-.179.667V54h.667v-.667a.667.667,0,0,1,.667-.667h2.333a1.333,1.333,0,0,0,0-2.667H105.333a.667.667,0,0,1,0-1.333h12V48h-12a1.333,1.333,0,1,0,0,2.667Z"
											transform="translate(-84.333)"
										></path>
										<rect
											class="a"
											width="1"
											height="1"
											transform="translate(33 48)"
										></rect>
									</g>
								</svg>
							</span>
							Dating</a
						>
					</li>
					<li class="">
						<a href="#">
							<span class="submenuicon">
								<svg width="20" height="20" viewBox="0 0 20 20">
									<path
										class="a"
										d="M19,2.667H16V1.333A1.333,1.333,0,0,0,14.667,0H5.333A1.333,1.333,0,0,0,4,1.333V7.667H1a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1H4v3A1.333,1.333,0,0,0,5.333,20h9.333A1.333,1.333,0,0,0,16,18.667v-8h3a1,1,0,0,0,1-1v-6A1,1,0,0,0,19,2.667Zm-6.436-2-.428.456a.667.667,0,0,1-.486.211H8.35a.669.669,0,0,1-.486-.211L7.436.667Zm-7.9.667A.667.667,0,0,1,5.333.667H6.522l.855.912A1.339,1.339,0,0,0,8.35,2h3.3a1.337,1.337,0,0,0,.973-.421l.855-.912h1.189a.667.667,0,0,1,.667.667V2.667h-5a1,1,0,0,0-1,1v4H4.667Zm-4,13.333v-6A.333.333,0,0,1,1,8.333H9.667A.333.333,0,0,1,10,8.667v6A.333.333,0,0,1,9.667,15H8a.333.333,0,1,0,0,.667v.667l-1.158-.725A.327.327,0,0,0,7,15.333.333.333,0,0,0,6.667,15H1A.333.333,0,0,1,.667,14.667Zm14,4.667H5.333a.667.667,0,0,1-.667-.667v-.519a1.32,1.32,0,0,0,.667.185h9.333a1.32,1.32,0,0,0,.667-.185v.519A.667.667,0,0,1,14.667,19.333ZM15.333,17a.667.667,0,0,1-.667.667H5.333A.667.667,0,0,1,4.667,17V15.667H5.678L7.649,16.9a.667.667,0,0,0,1.017-.567v-.667h1a1,1,0,0,0,1-1v-4h.667v.667A.667.667,0,0,0,12,12a.679.679,0,0,0,.353-.1l1.969-1.233h1.011Zm4-7.333A.333.333,0,0,1,19,10H13.333a.333.333,0,0,0-.333.333.328.328,0,0,0,.157.276L12,11.333v-.667A.333.333,0,1,0,12,10H10.667V8.667A1,1,0,0,0,10,7.728V3.667a.333.333,0,0,1,.333-.333H19a.333.333,0,0,1,.333.333Z"
									></path>
									<path
										class="a"
										d="M41.39,13.841a.672.672,0,0,0-.842.035l-.847.711-2.63-1.5a.683.683,0,0,0-.559-.052.693.693,0,0,0-.414.394l-1.046,2.575a.69.69,0,0,0,.241.836.672.672,0,0,0,.845-.044l1.154-1,2.242,1.724a.679.679,0,0,0,.593.118.686.686,0,0,0,.459-.408l1.041-2.562a.691.691,0,0,0-.237-.833ZM39.956,17.01,37.7,15.273a.684.684,0,0,0-.867.029l-1.142,1-.02-.047L36.74,13.67l2.631,1.5a.683.683,0,0,0,.78-.075l.838-.716.02.046L39.958,17.01Z"
										transform="translate(-23.331 -8.667)"
									></path>
									<path
										class="a"
										d="M10.9,32.667a.686.686,0,0,0,.638-.431l1.041-2.562a.691.691,0,0,0-.238-.833.671.671,0,0,0-.841.035l-.846.712-2.63-1.5a.682.682,0,0,0-.56-.052.692.692,0,0,0-.413.394L6,31.007a.689.689,0,0,0,.242.836.67.67,0,0,0,.845-.044l1.154-1,2.243,1.725A.679.679,0,0,0,10.9,32.667Zm.009-.657L8.648,30.273a.684.684,0,0,0-.867.029l-1.141,1-.021-.047L7.692,28.67l2.629,1.5a.682.682,0,0,0,.78-.075l.838-.716.021.046L10.909,32.01Z"
										transform="translate(-3.965 -18.667)"
									></path>
								</svg>
							</span>
							Instant Messaging</a
						>
					</li>
					<li>
						<a href="#">
							<span class="submenuicon">
								<svg width="18.668" height="20" viewBox="0 0 18.668 20">
									<g transform="translate(-15.977 0)">
										<g transform="translate(15.977 0)">
											<g transform="translate(0 0)">
												<path
													class="a"
													d="M34.623,7.888a.267.267,0,0,0-.009-.026.032.032,0,0,0,0-.012.332.332,0,0,0-.059-.082c-.005-.006-.012-.01-.018-.015a.344.344,0,0,0-.076-.051l-.03-.013a.33.33,0,0,0-.115-.023H20.6l-.088-.109,4.3-1.35.052-.016.077-.024,4.134-1.3.877-.275,1.3-.407,3.156-.99a.333.333,0,0,0,.218-.418h0l-.8-2.545c0-.006-.007-.01-.009-.016a.328.328,0,0,0-.045-.082C33.771.126,33.767.117,33.76.11L33.753.1a.322.322,0,0,0-.08-.06c-.008,0-.016-.006-.024-.01A.341.341,0,0,0,33.563,0L33.53,0a.324.324,0,0,0-.117.013L24.1,2.938l-.862.271-1.48.465L17.533,5H16.31a.333.333,0,0,0-.333.333V19a1,1,0,0,0,1,1H33.645a1,1,0,0,0,1-1V8c0-.006,0-.012,0-.018A.333.333,0,0,0,34.623,7.888Zm-.978.444-1.5,2H30.312l1.5-2Zm-2.667,0-1.5,2H27.645l1.5-2Zm-2.667,0-1.5,2H24.978l1.5-2Zm-2.667,0-1.5,2H22.311l1.5-2Zm-2.667,0-1.5,2h-.167V8.666a.333.333,0,0,0-.073-.208l-.1-.121ZM33.495,1.387l.4,1.272-.955.3Zm-1.732-.156L32.979.85l-.833,2.357-1.11.348-.64.2L31.229,1.4Zm-2.864.9,1.534-.482L29.6,4.006l-1.749.549L28.683,2.2Zm-1.009.317L27.056,4.8l-1.749.549L26.14,3ZM23.6,3.8l1.749-.55L24.511,5.6l-1.749.549Zm-.793.248L21.969,6.4l-1.077.339-.672.211.833-2.358Zm-2.548.8L19.67,6.5,18.73,5.322Zm-3.611.822h1.507l1.541,1.927.491.614.233.293.04.05.185.231v1.552h-4ZM33.979,19a.333.333,0,0,1-.333.333H16.977A.333.333,0,0,1,16.644,19V11H33.979Zm0-8.667h-1l1-1.333Z"
													transform="translate(-15.977 0)"
												></path>
											</g>
										</g>
										<g transform="translate(17.31 8.999)">
											<g transform="translate(0)">
												<rect class="a" width="0.667" height="0.667"></rect>
											</g>
										</g>
										<g transform="translate(17.31 6.332)">
											<g transform="translate(0)">
												<rect class="a" width="0.667" height="0.667"></rect>
											</g>
										</g>
										<g transform="translate(19.311 8.999)">
											<g transform="translate(0)">
												<rect class="a" width="0.667" height="0.667"></rect>
											</g>
										</g>
										<g transform="translate(17.977 13)">
											<g transform="translate(0)">
												<rect
													class="a"
													width="14.668"
													height="0.667"
												></rect>
											</g>
										</g>
										<g transform="translate(17.977 15.667)">
											<g transform="translate(0)">
												<path
													class="a"
													d="M63.977,375.958v.667h4.334v2h.667v-2h4.667v2h.667v-2h4.334v-.667Z"
													transform="translate(-63.977 -375.958)"
												></path>
											</g>
										</g>
									</g>
								</svg>
							</span>
							Media and Entertainment</a
						>
					</li>
				</ul>
			</div>
			<div class="col-3">
				<span class="a-t px-4 py-2 cc-h fxt-srvs-header">
					<svg
						enable-background="new 0 0 64 64"
						height="512"
						viewBox="0 0 64 64"
						width="512"
					>
						<g>
							<path
								d="m31.524 41c1.864 0 3.616-.726 4.934-2.044l7.956-7.956h4.586c1.654 0 3-1.346 3-3v-2c0-.92-.425-1.735-1.08-2.286.665-.714 1.08-1.664 1.08-2.714v-1.791c0-.68.322-1.293.862-1.64 2.591-1.666 4.138-4.496 4.138-7.569 0-2.561-1.096-5.008-3.006-6.714-1.909-1.706-4.477-2.516-7.039-2.228-4.051.458-7.365 3.723-7.88 7.763-.447 3.51 1.118 6.867 4.084 8.762.518.331.84.97.84 1.667v1.957c-.579.188-1.115.494-1.558.938l-2.441 2.441-8.026 8.025c-1.117-.991-3.355-2.792-5.658-3.559-1.107-.37-2.329-.649-3.63-.832-.961-.136-1.686-.985-1.686-1.975v-1.328c1.529-.888 2.739-2.264 3.411-3.918h.589c2.206 0 4-1.794 4-4 0-.855-.275-1.645-.734-2.296l.01-.021c.474-.946.724-2.005.724-3.064 0-2.612-1.452-4.961-3.789-6.131l-.222-.111c-.061-2.422-2.04-4.376-4.476-4.376h-6.513c-3.716 0-6.766 2.911-6.987 6.573l-.196.196c-1.171 1.172-1.817 2.73-1.817 4.386 0 .668.107 1.328.318 1.962l.273.819c-.367.604-.591 1.306-.591 2.064 0 2.206 1.794 4 4 4h.589c.672 1.654 1.882 3.03 3.411 3.918v1.434c0 1.007-.753 1.859-1.752 1.984l-2.829.354c-1.859.232-3.613 1.091-4.938 2.416-1.6 1.599-2.481 3.725-2.481 5.988v15.906c0 1.654 1.346 3 3 3h2c.352 0 .686-.072 1-.184v7.184h20v-23.497l1.184.646c1.022.557 2.176.851 3.34.851zm18.476-20c0 .908-.613 1.669-1.444 1.912-.565-.952-1.49-1.603-2.556-1.822v-.09zm-8.94-11.926c.4-3.137 2.974-5.672 6.12-6.027 2.026-.236 3.975.385 5.481 1.73 1.486 1.328 2.339 3.232 2.339 5.223 0 2.39-1.204 4.591-3.22 5.888-1.057.679-1.703 1.833-1.768 3.112h-4.028c-.074-1.291-.711-2.439-1.749-3.103-2.307-1.474-3.524-4.088-3.175-6.823zm2.796 14.485c.355-.355.846-.559 1.348-.559.727 0 1.38.403 1.705 1.054l.473.946h1.618c.551 0 1 .448 1 1v2c0 .552-.449 1-1 1h-4.586l-3-3zm-23.117 10.152-2.398-1.919 1.827-2.742c.02.02.04.039.06.058zm-1.81 8.946-1.929 1.929-1.929-1.929 1.506-9.038.423-.338.423.338zm-5.17-13.434c.038-.037.078-.071.115-.109l1.785 2.678-2.398 1.919zm11.241-10.223h-.069c.041-.328.069-.661.069-1v-3c1.103 0 2 .897 2 2s-.897 2-2 2zm-16 0c-1.103 0-2-.897-2-2s.897-2 2-2v3c0 .339.028.672.069 1zm.016-6h-.016c-.648 0-1.252.17-1.794.444-.135-.417-.206-.85-.206-1.289 0-1.122.438-2.178 1.231-2.973l.769-.768v-.414c0-2.757 2.243-5 5-5h6.513c1.371 0 2.487 1.116 2.487 2.487 0 1.072-.684 2.02-1.7 2.358l-.616.205.632 1.898.616-.206c1.184-.395 2.111-1.25 2.625-2.325 1.509.866 2.443 2.445 2.443 4.201 0 .6-.118 1.197-.335 1.756-.508-.234-1.069-.374-1.665-.374v-2h-4.528c-2.772 0-5.547-.655-8.025-1.895l-.447-.223-.447.224c-1.503.752-2.453 2.231-2.537 3.894zm1.984 5v-4.764c0-.842.395-1.611 1.054-2.101 2.625 1.222 5.523 1.865 8.418 1.865h2.528v5c0 3.309-2.691 6-6 6s-6-2.691-6-6zm6 8c.692 0 1.359-.097 2-.263v.508c0 .279.036.55.091.815l-2.091 3.137-2.069-3.104c.045-.241.069-.489.069-.741v-.615c.641.166 1.308.263 2 .263zm-12.105 6.52c1.012-1.013 2.352-1.668 3.772-1.846l2.829-.354c.046-.006.087-.022.132-.029l-.889 7.998 3.499-2.799-1.309 7.853 4.071 4.071 4.071-4.071-1.309-7.853 3.499 2.799-.9-8.1c.016.003.031.009.048.011 1.181.166 2.283.417 3.275.748 2.04.68 4.139 2.419 5.088 3.272l-.666 1.333 1.789.895.927-1.855 7.178-7.179 2.586 2.586-7.542 7.542c-.94.94-2.19 1.458-3.52 1.458-.83 0-1.654-.21-2.383-.607l-2.124-1.158c.043-.576.277-1.114.69-1.527l-1.415-1.414c-.833.833-1.292 1.941-1.292 3.12v11.586h-14.127c-.137-.476-.38-.921-.733-1.274l-1.14-1.14v-9.172c0-1.179-.459-2.287-1.292-3.121l-1.415 1.414c.456.456.707 1.063.707 1.707v8.586h-4v-8.906c0-1.703.691-3.37 1.895-4.574zm1.105 21.48h-2c-.551 0-1-.448-1-1v-5h4.586l1.14 1.14c.174.174.274.416.274.663 0 .357-.199.679-.518.838l-1.482.741v.618 1c0 .552-.449 1-1 1zm12 7v-2.838c0-1.46.931-2.751 2.316-3.214l-.633-1.896c-1.112.371-2.037 1.078-2.684 1.985-.646-.907-1.572-1.615-2.684-1.985l-.633 1.896c1.387.463 2.318 1.754 2.318 3.214v2.838h-7v-8-.382l.376-.188c.624-.312 1.1-.82 1.371-1.43h14.253v10z"
							></path>
							<path
								d="m52.707 7.707-1.414-1.414-5.293 5.293-1.293-1.293-1.414 1.414 2.707 2.707z"
							></path>
							<path
								d="m46 51v-1.586c0-1.331-1.083-2.414-2.414-2.414-.635 0-1.257.258-1.707.707l-3.293 3.293h-4.586c-1.654 0-3 1.346-3 3v4c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3v-4c0-1.654-1.346-3-3-3zm1 7c0 .552-.449 1-1 1h-12c-.551 0-1-.448-1-1v-4c0-.552.449-1 1-1h5.414l3.878-3.878c.241-.241.708-.045.708.292v3.586h2c.551 0 1 .448 1 1z"
							></path>
							<path d="m35 55h10v2h-10z"></path>
							<path
								d="m60 33h-12c-1.654 0-3 1.346-3 3v4c0 1.654 1.346 3 3 3v1.586c0 1.331 1.083 2.414 2.414 2.414.635 0 1.257-.258 1.707-.707l3.293-3.293h4.586c1.654 0 3-1.346 3-3v-4c0-1.654-1.346-3-3-3zm1 7c0 .552-.449 1-1 1h-5.414l-3.878 3.878c-.241.241-.708.045-.708-.292v-3.586h-2c-.551 0-1-.448-1-1v-4c0-.552.449-1 1-1h12c.551 0 1 .448 1 1z"
							></path>
							<path d="m49 37h10v2h-10z"></path>
						</g>
					</svg>
					<h5 class="px-2">Other Solutions</h5>
				</span>
				<ul class="serv-ul">
					<li>
						<a href="#">
							<span class="submenuicon">
								<svg width="19.707" height="20" viewBox="0 0 19.707 20">
									<g transform="translate(-1 -0.382)">
										<path
											class="a"
											d="M33.152,9A4.152,4.152,0,1,0,37.3,13.152,4.157,4.157,0,0,0,33.152,9Zm-3.513,4.152a3.491,3.491,0,0,1,.024-.394l1-.661.892.588v.934l-.893.588-1-.659A3.608,3.608,0,0,1,29.639,13.152Zm5.673-1.6-.9.6-.936-.468v-1.2l1.082-.542a3.507,3.507,0,0,1,.685.4Zm-2.16,2.523-.958-.479v-.883l.958-.479.958.479v.883Zm-.319-2.4-.936.468-.9-.6.072-1.216a3.5,3.5,0,0,1,.685-.4l1.084.542Zm-1.84,3.077.9-.6.936.468v1.2l-1.082.542a3.507,3.507,0,0,1-.685-.4Zm2.479-.127.936-.468.9.6-.072,1.216a3.5,3.5,0,0,1-.685.4l-1.084-.542Zm2.17-.42-.892-.588v-.934l.893-.588,1,.659a3.608,3.608,0,0,1,.024.4,3.491,3.491,0,0,1-.024.394Zm.309-2.671-.033-.543a3.505,3.505,0,0,1,.489.844Zm-2.312-1.86-.486.244-.487-.244a3.151,3.151,0,0,1,.974,0Zm-3.253,1.318-.032.542-.457.3A3.5,3.5,0,0,1,30.385,10.995ZM29.9,14.467l.457.3.033.543a3.51,3.51,0,0,1-.489-.844Zm2.769,2.161.486-.244.487.244a3.151,3.151,0,0,1-.974,0Zm3.253-1.318.032-.542.457-.3A3.5,3.5,0,0,1,35.919,15.31Z"
											transform="translate(-19.057 -5.865)"
										></path>
										<path
											class="a"
											d="M0,0H4.065V.639H0Z"
											transform="translate(17.381 3.549) rotate(-45)"
										></path>
										<path
											class="a"
											d="M0,0H.9V.639H0Z"
											transform="translate(17.7 1.314) rotate(-45)"
										></path>
										<path
											class="a"
											d="M0,0H.9V.639H0Z"
											transform="translate(16.423 2.591) rotate(-45)"
										></path>
										<path
											class="a"
											d="M0,0H2.71V.639H0Z"
											transform="translate(18.339 4.507) rotate(-45)"
										></path>
										<circle
											class="a"
											cx="0.319"
											cy="0.319"
											r="0.319"
											transform="translate(6.11 4.412)"
										></circle>
										<path
											class="a"
											d="M10.339,15.967l.278-.278-.479-1.915A6.443,6.443,0,0,0,6.11,9.285V8.245h.639A1.279,1.279,0,0,0,8.027,6.967V6.141L8.8,5.37l-.226-.226a1.849,1.849,0,0,1-.545-1.317V3.741A1.6,1.6,0,0,0,9.3,2.176V.382L8.842.613A3.027,3.027,0,0,1,7.618.931l-3.284.149A3.493,3.493,0,0,0,2.642,7.532l.913.571v.979L1.607,11.274a2.4,2.4,0,0,0,1.8,4h.515l.343,2.4.878-.439a17.762,17.762,0,0,1-.163,1.814l-.191,1.335h7.165l-.286-1.145a12.821,12.821,0,0,0-1.325-3.27ZM7.388,5.877v.452H6.749A.639.639,0,0,1,6.11,5.69H5.472A1.279,1.279,0,0,0,6.749,6.967h.639a.639.639,0,0,1-.639.639H4.833v.639h.639v.839A6.474,6.474,0,0,0,4.194,8.9V6.2l-.545-.545a.318.318,0,0,1-.094-.226V5.37a.32.32,0,0,1,.319-.319h.319V4.093a.32.32,0,0,1,.319-.319H7.388v.055a2.482,2.482,0,0,0,.521,1.528ZM2.98,6.99A2.854,2.854,0,0,1,4.363,1.719L7.647,1.57a3.659,3.659,0,0,0,1.019-.192v.8a.959.959,0,0,1-.958.958H4.513a.959.959,0,0,0-.958.958v.374a.96.96,0,0,0-.639.9v.055A.952.952,0,0,0,3.2,6.1l.358.358v.889Zm-1.341,5.88a1.758,1.758,0,0,1,.289-.959l1.34.575-.186.232h-.8v.639h5.11a.639.639,0,0,1,0,1.278H3.4a1.766,1.766,0,0,1-1.763-1.763Zm2.923,2.4H7.388a1.278,1.278,0,1,0,0-2.555H3.9l.862-1.078-.5-.4-.582.728-1.33-.57L4.013,9.528a5.805,5.805,0,0,1,5.5,4.4l.391,1.565-.862.862a.681.681,0,0,1-.765.124l-.807-.4a1.7,1.7,0,0,0-1.5.023L4.767,16.7ZM9.09,19.743A6.533,6.533,0,0,0,9.3,18.094v-.268H8.666v.268a5.889,5.889,0,0,1-.24,1.649H5.52l.087-.606a18.381,18.381,0,0,0,.178-2.228l.479-.24a1.051,1.051,0,0,1,.925-.023l.808.4a1.335,1.335,0,0,0,1.5-.244l.37-.37a12.174,12.174,0,0,1,1.174,2.955l.088.351Z"
										></path>
									</g>
								</svg>
							</span>
							Fantasy Sports</a
						>
					</li>
					<li>
						<a href="#">
							<span class="submenuicon">
								<svg width="19.921" height="20" viewBox="0 0 19.921 20">
									<g transform="translate(-1.012)">
										<g transform="translate(1.012)">
											<path
												class="a"
												d="M156.97,327.043a.885.885,0,1,0,0-1.77h-3.551a.885.885,0,1,0,0,1.77Zm-3.85-.885a.3.3,0,0,1,.3-.3h3.551a.3.3,0,1,1,0,.6h-3.551A.3.3,0,0,1,153.12,326.158Z"
												transform="translate(-146.615 -312.567)"
											></path>
											<path
												class="a"
												d="M259.915,205.823a1.465,1.465,0,1,0,1.465-1.465A1.466,1.466,0,0,0,259.915,205.823Zm1.465-.879a.879.879,0,1,1-.879.879A.88.88,0,0,1,261.38,204.944Z"
												transform="translate(-249.802 -196.375)"
											></path>
											<path
												class="a"
												d="M107.836,204.358a1.465,1.465,0,1,0,1.465,1.465A1.466,1.466,0,0,0,107.836,204.358Zm0,2.344a.879.879,0,1,1,.879-.879A.88.88,0,0,1,107.836,206.7Z"
												transform="translate(-102.255 -196.375)"
											></path>
											<path
												class="a"
												d="M178.316,428a.293.293,0,0,0,.293-.293v-1.445a.293.293,0,0,0-.293-.293h-2.891a.293.293,0,0,0-.293.293v1.445a.293.293,0,0,0,.293.293Zm-2.6-1.445h2.3v.859h-2.3Z"
												transform="translate(-168.33 -409.332)"
											></path>
											<path
												class="a"
												d="M20.64,3.736a.293.293,0,0,0,.293-.293V1.082A1.083,1.083,0,0,0,19.851,0H11.722A1.083,1.083,0,0,0,10.64,1.082V5.6H7.228a.293.293,0,0,0,0,.586H10.64v.1a1.075,1.075,0,0,0,.121.5H5.251A1.478,1.478,0,0,0,3.774,8.264v2.368a1.478,1.478,0,0,0,1.477,1.477h8.681a1.478,1.478,0,0,0,1.477-1.477V8.264a1.469,1.469,0,0,0-.3-.891h.9v6.415a1.287,1.287,0,0,1-1.285,1.285H4.461a1.287,1.287,0,0,1-1.285-1.285V7.475A1.287,1.287,0,0,1,4.461,6.189h1.4a.293.293,0,0,0,0-.586h-1.4A1.873,1.873,0,0,0,2.59,7.475v.5h-.5A1.083,1.083,0,0,0,1.012,9.053V12.21a1.083,1.083,0,0,0,1.082,1.082h.5v.5a1.873,1.873,0,0,0,1.871,1.871H6.311a2.656,2.656,0,0,0-1,2.075v.232a.293.293,0,0,0,.586,0v-.232a2.077,2.077,0,0,1,2.075-2.075H11.13A2.077,2.077,0,0,1,13.2,17.734v1.68H12.37v-.5a.293.293,0,1,0-.586,0v.5H7.319v-.5a.293.293,0,1,0-.586,0v.5H5.9v-.08a.293.293,0,0,0-.586,0v.373A.293.293,0,0,0,5.606,20H13.5a.293.293,0,0,0,.293-.293V17.734a2.656,2.656,0,0,0-1-2.075h1.928a1.873,1.873,0,0,0,1.871-1.871v-.5h.5a1.083,1.083,0,0,0,1.082-1.082V9.053A1.083,1.083,0,0,0,17.14,7.972l.757-.6h1.954a1.083,1.083,0,0,0,1.082-1.082V4.814a.293.293,0,0,0-.586,0V6.291a.5.5,0,0,1-.5.5H17.795a.293.293,0,0,0-.182.063l-1.021.808V7.08a.293.293,0,0,0-.293-.293H11.722a.5.5,0,0,1-.5-.5V1.082a.5.5,0,0,1,.5-.5h8.129a.5.5,0,0,1,.5.5V3.443a.293.293,0,0,0,.293.293ZM2.094,12.706a.5.5,0,0,1-.5-.5V9.053a.5.5,0,0,1,.5-.5h.5v4.149h-.5ZM17.585,9.053V12.21a.5.5,0,0,1-.5.5h-.5V8.557h.5A.5.5,0,0,1,17.585,9.053Zm-2.762-.789v2.368a.892.892,0,0,1-.891.891H5.251a.892.892,0,0,1-.891-.891V8.264a.892.892,0,0,1,.891-.891h8.681A.892.892,0,0,1,14.823,8.264Z"
												transform="translate(-1.012)"
											></path>
											<path
												class="a"
												d="M288.512,87.167a.293.293,0,0,0-.293-.293h-7.1a.293.293,0,0,0,0,.586h7.1A.293.293,0,0,0,288.512,87.167Z"
												transform="translate(-269.893 -83.48)"
											></path>
											<path
												class="a"
												d="M288.219,56.61h-7.1a.293.293,0,0,0,0,.586h7.1a.293.293,0,0,0,0-.586Z"
												transform="translate(-269.893 -54.399)"
											></path>
											<path
												class="a"
												d="M281.116,117.138a.293.293,0,0,0,0,.586h4.341a.293.293,0,1,0,0-.586Z"
												transform="translate(-269.893 -112.562)"
											></path>
										</g>
									</g>
								</svg>
							</span>
							Chatbot</a
						>
					</li>
				</ul>
			</div>
		</div>
		<DownP></DownP>
	</div>
</template>

<script>
import DownP from './DownP.vue';
export default {
	components: {
		DownP
	}
};
</script>

<style scoped>
.col-3 {
	padding: 0;
}

.solution-div {
	width: 100vw;
}

.os-wrapper {
	position: relative;
	margin: 0 auto;
	max-width: 98%;
}

.os-wrapper h4 {
	text-align: center;
	white-space: nowrap;
}
.os-wrapper span {
	display: flex;
	align-items: center;
}

.os-wrapper svg {
	width: 60px;
	height: 60px;
}

.serv-ul {
	list-style: none;
	padding: 0 24px;
}

.serv-ul li a {
	padding: 10px 0;
	display: flex;
	align-items: center;
	justify-content: start;
	color: #000;
	width: 100%;
}

.cc-h {
	border-bottom: 1px solid #000;
}

.cc-h:hover {
	background: #1977cc;
	color: #fff;
	border-bottom: #1977cc 1px solid;
}
.cc-h:hover svg {
	fill: #fff;
}

.serv-ul li a svg {
	width: 30px;
	height: 30px;
	margin-right: 20px;
}

.serv-ul li:hover a {
	color: #1977cc;
}

.serv-ul li:hover a svg {
	fill: #1977cc;
}
.fxt-srvs-header svg {
	max-width: 38px;
	margin-right: 5px;
}
.fxt-srvs-header h5 {
	font-size: 1rem;
}
.serv-ul li {
	font-size: 0.8rem;
}
@media (max-width: 991px) {
	#solution-div {
		display: none !important;
	}
}
</style>
